import client1 from "@/assets/client_1.jpeg";
import client2 from "@/assets/client_2.jpeg";
import client3 from "@/assets/client_3.jpeg";
import client4 from "@/assets/client_4.jpeg";
import { ArrowRight } from "lucide-react";
import aqibImg from "@/assets/aqib.png";

const HeroSection = () => {
  return (
    <section className="relative pt-24 pb-12 md:pb-16 lg:pt-32 lg:pb-24 overflow-hidden">
      <div className="absolute right-0 top-20 w-72 h-72 md:w-[500px] md:h-[500px] lg:w-[600px] lg:h-[600px] rounded-full gradient-hero opacity-20 blur-3xl -z-10" />

      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          
          {/* LEFT COLUMN: Text and CTA */}
          <div className="animate-fade-up text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary/10 text-primary text-xs font-semibold tracking-widest uppercase mb-4 md:mb-6">
              Welcome to Graphic Lines
            </span>
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight mb-4 md:mb-6">
              <span className="text-primary">Professional</span>
              <br />
              <span className="text-foreground">Digital Agency</span>
            </h1>
            <p className="text-muted-foreground text-sm md:text-base lg:text-lg max-w-lg mx-auto lg:mx-0 mb-6 md:mb-8 font-body leading-relaxed">
              At Graphic Lines, we help businesses grow through creative design, professional video editing, and strategic social media marketing. Our team focuses on high-quality visuals, engaging content, and smart digital strategies that build trust, attract customers, and scale your brand online.
            </p>
            <a
              href="https://wa.me/+923058559591"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-6 py-3 md:px-8 md:py-4 rounded-full gradient-cta text-primary-foreground font-display font-semibold text-sm hover:opacity-90 transition-opacity duration-200 shadow-lg"
            >
              Book A Free Consultation
              <ArrowRight className="w-4 h-4" />
            </a>

            <div className="flex items-center gap-3 mt-6 md:mt-8 justify-center lg:justify-start">
              <div className="flex -space-x-2">
                {[client1, client2, client3, client4].map((imgSrc, index) => (
                  <img
                    key={index}
                    src={imgSrc}
                    alt={`Satisfied Client ${index + 1}`}
                    className="w-8 h-8 md:w-9 md:h-9 rounded-full object-cover border-2 border-background"
                  />
                ))}
              </div>
              <span className="text-sm font-semibold text-primary">73+ Satisfied Clients</span>
            </div>
          </div> {/* <-- This closing tag was missing in your code! */}

          {/* RIGHT COLUMN: Image and Floating Badges */}
          <div className="relative flex justify-center animate-fade-up delay-200">
            <div className="relative w-60 h-60 sm:w-72 sm:h-72 md:w-80 md:h-80 lg:w-[420px] lg:h-[420px]">
              <div className="absolute inset-0 rounded-full gradient-hero opacity-80" />
              <div className="w-60 h-60 sm:w-72 sm:h-72 md:w-80 md:h-80 lg:w-96 lg:h-96 rounded-full gradient-hero mx-auto relative overflow-hidden flex items-end justify-center">
                <img
                  src={aqibImg}
                  alt="Aqib Khan - Graphic Lines founder"
                  className="w-10/12 lg:w-11/12 h-auto z-10 object-contain object-bottom"
                />
              </div>

              <div className="absolute top-4 right-0 md:top-8 bg-card rounded-xl shadow-lg px-3 py-2 md:px-4 md:py-3 animate-float z-20">
                <p className="text-base md:text-lg font-display font-bold text-primary">80+</p>
                <p className="text-[10px] md:text-xs text-muted-foreground">Brands Joined</p>
              </div>
              <div className="absolute bottom-8 left-0 md:bottom-12 bg-card rounded-xl shadow-lg px-3 py-2 md:px-4 md:py-3 animate-float delay-200 z-20">
                <p className="text-base md:text-lg font-display font-bold text-secondary">3+</p>
                <p className="text-[10px] md:text-xs text-muted-foreground">Years Experience</p>
              </div>
            </div>

            {["facebook", "youtube", "instagram", "tiktok"].map((_, i) => (
              <div
                key={i}
                className="absolute w-8 h-8 md:w-10 md:h-10 rounded-full bg-card shadow-md hidden sm:flex items-center justify-center animate-float"
                style={{
                  top: `${20 + i * 22}%`,
                  right: i % 2 === 0 ? "-2%" : undefined,
                  left: i % 2 !== 0 ? "-2%" : undefined,
                  animationDelay: `${i * 0.5}s`,
                }}
              >
                <div className="w-3 h-3 md:w-4 md:h-4 rounded-full gradient-hero" />
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
};

export default HeroSection;
